import * as React from 'react';
import { SGBase, SGBaseProps, OptionalColor, FillOptionalColor } from './sgbase';
import bind from 'bind-decorator';
import { SgNode, CreateSgNode, FullyQualifyIDIfNeeded, TraversalState, BuildSgNodeReturn } from './sgproto';

interface FresnelProps
{
	color ?: OptionalColor | string;
	opacity ?: number;
	strength ?: number;
}

export enum ERenderModelCulling
{
	None,
	Backface,
}

interface RenderModelProps extends SGBaseProps
{
	source: string;
	"texture-id"?: string;
	fresnel?: FresnelProps;
	wireframe?: boolean;
	solid?: boolean;
	culling?: ERenderModelCulling;
	"no-depth-write"?: boolean;
	"no-depth-test"?: boolean;
}

export class RenderModel extends SGBase<RenderModelProps, null>
{
	constructor( props: any )
	{
		super( props );
		super.setBuildNodeOverride( this.buildNode );
	}

	public getNodeType(): string
	{
		return "rendermodel";
	}

	@bind private buildNode( traversalState: TraversalState, domNode: HTMLElement ): BuildSgNodeReturn
	{
		const node = this.createSgNode( domNode );
		node.properties.source = this.props.source;
		node.properties["texture-id"] = FullyQualifyIDIfNeeded( this.props["texture-id"] );
		if ( this.props.fresnel )
		{
			let fresnel = this.props.fresnel;
			if ( typeof fresnel.color == "string" )
			{
				node.properties.color = fresnel.color;
			}
			else
			{
				let color = FillOptionalColor( fresnel.color, { r: 0, g: 0, b: 0 } );
				node.properties.color = [ color.r, color.g, color.b ];
			}
			node.properties.opacity = fresnel.opacity ? fresnel.opacity : 1;
			node.properties.strength = fresnel.strength ? fresnel.strength : 1;
		}
		node.properties.wireframe = this.props.wireframe;
		node.properties.solid = this.props.solid;
		node.properties.culling = this.props.culling;
		node.properties["no-depth-write"] = this.props["no-depth-write"];
		node.properties["no-depth-test"] = this.props["no-depth-test"];
		return [traversalState, node];
	}
}

